export default class Events {
  constructor($container) {
    this.$container = $container || document;
  }

  bind(types, selector, listener, options) {
    var delegate = true;
    var $container = this.$container;
    if (typeof selector === 'function') {
      options = listener;
      listener = selector;
      delegate = false;
    } else if (typeof selector === 'object') {
      delegate = false;
      $container = selector;
    }
    types.split(' ').forEach((type) => {
      $container.addEventListener(
        type.toLowerCase(),
        (event) => {
          if (delegate) {
            let $element = event.target.closest(selector);
            if ($element) {
              listener.call($element, event, $element);
            }
          } else {
            listener.call($container, event, $container);
          }
        },
        options
      );
    });
  }
}
